export const addSupplierTransaction = async (supplierTransactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addSupplierTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...supplierTransactionData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = supplierTransactionData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Supplier Transaction Response:', response);
    return jsonResponse;
};
export const updateSupplierTransaction = async (supplierTransactionId, supplierTransactionData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateSupplierTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: supplierTransactionId, ...supplierTransactionData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = supplierTransactionData;
        data.id = supplierTransactionId;
        jsonResponse.data = data;
    }
    console.log('Update Supplier Transaction Response:', response);
    return jsonResponse;
};
export const deleteSupplierTransaction = async (supplierTransactionId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteSupplierTransactions", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: supplierTransactionId})
    });
    return await response.json();
};
